export enum BreadcrumbBackground {
  withHeader = 'bg-3',
  withoutHeader = 'bg-2',
}
